import { FC } from 'react';
import { LinkProps } from 'react-router';

import { IDataTestId } from '../../../../../custom';
import ButtonLink from './ButtonLink';

const PrimaryButtonLink: FC<LinkProps & IDataTestId & { label: string }> = (props) => {
  const { label, ...rest } = props;

  return (
    <ButtonLink
      linkProps={{ ...rest, className: `tw:w-fit ${rest?.className || ''}` }}
      variant="primary"
      testId={props?.['data-testid'] || 'primary-btn-link'}
      label={label}
    />
  );
};

export default PrimaryButtonLink;
